import { useTranslation } from 'react-i18next';
import { useUgcDraft } from '../../../../models/ugc-draft/context';
import {
  PlainEditor,
  PlainEditorProps,
} from '../../../../components/ui/plain-editor';
import { MAXIMUM_TITLE_LENGTH } from '../../../../models/ugc-draft/context';
import '../form.scss';

const trackingContext: PlainEditorProps['trackingContext'] = {
  contentSection: 'title',
};

const TitleInput = () => {
  const { ugcDraft, isPersisting, updateUgcDraftFormState } = useUgcDraft();
  const { t } = useTranslation();

  const onTextChange = (title: string) => {
    updateUgcDraftFormState({ title });
  };

  return (
    <PlainEditor
      className={'ugc-editor'}
      aria-label={t('ugc_draft.field_title')}
      disabled={isPersisting}
      defaultValue={ugcDraft.title || ''}
      maximumCharacter={MAXIMUM_TITLE_LENGTH}
      onChange={onTextChange}
      placeholder={t('ugc_draft.field_title_placeholder')}
      trackingContext={trackingContext}
    />
  );
};

export default TitleInput;
